import { useLayoutEffect, useEffect } from 'react';
import { isClientSide } from 'utils/host-config';

export const useIsomorphicLayoutEffect = isClientSide() ? useLayoutEffect : useEffect;

export type DataAttributes = {
  [K in `data-${string}`]: string | number | boolean | undefined;
};


/**
 * A type that extends a given type with data attributes.
 * @example
 * type MyComponentProps = PropsWithDataAttributes<{
 *   name: string;
 * }>;
 *
 * const MyComponent = (props: MyComponentProps) => {
 *   return <div>{props.name}</div>;
 * };
 *
 * const myComponentProps: MyComponentProps = {
 *   name: 'Potato',
 *   'data-testid': 'my-component',
 * };
 */
export type PropsWithDataAttributes<T = object> = T & DataAttributes;